import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { CommonService } from '@services/common.service';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PermissionGroup } from '@app/models/permission/permission-group';



export const itemOne: any = [
    {
        "permissionGroupId": "2ca21562-ff2f-4066-8c6f-fac44420f41a",
        "code": "PERM_GRP_ADMIN_LOGIN",
        "sequence": 0,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "20d7d125-90a4-44b5-8a46-df29bd31823d",
                "code": "PERM_SET_ADMIN_LOGIN",
                "sequence": 0,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "dd956216-6c40-4fbe-b0a5-3e4b44b67ed9",
                        "code": "PERM_ADMIN_LOGIN",
                        "name": "PERM_ADMIN_LOGIN",
                        "sequence": 0,
                        "description": null,
                        "type": "ADMIN"
                    },
                    {
                        "permissionId": "488e6f70-c33f-4c01-ac58-aee31f5d1893",
                        "code": "PERM_USER_CHANGE_SELF_PASSWORD",
                        "name": "PERM_USER_CHANGE_SELF_PASSWORD",
                        "sequence": 1,
                        "description": null,
                        "type": "ADMIN"
                    },
                    {
                        "permissionId": "75e1ab75-c851-4b9d-b2e0-bbeee155c296",
                        "code": "PERM_USER_SELF_READ",
                        "name": "PERM_USER_SELF_READ",
                        "sequence": 2,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "56ac2fe1-d8b4-4c48-afe3-2ff5352b4f01",
        "code": "PERM_GRP_BUSINESS_PARTNER",
        "sequence": 1,
        "category": "ADMIN",
        "permissionSets": []
    },
    {
        "permissionGroupId": "583c1c3d-8c8a-4f4d-8839-f2b3fa82ea73",
        "code": "PERM_GRP_USER",
        "sequence": 1,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "b279efbf-c8ff-4f75-80f4-2d8d820fe916",
                "code": "PERM_SET_USER_CREATE",
                "sequence": 7,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "d08758c7-bfb3-4a7d-adeb-63a2dc797fdd",
                        "code": "PERM_USER_CREATE",
                        "name": "PERM_USER_CREATE",
                        "sequence": 9,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "c1bbff52-38a0-4755-9137-9337c8e23817",
                "code": "PERM_SET_USER_UPDATE",
                "sequence": 8,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "160212f0-2dce-4e41-b80e-9bf4354433c3",
                        "code": "PERM_USER_UPDATE",
                        "name": "PERM_USER_UPDATE",
                        "sequence": 10,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "c067e40f-72a5-4e12-8118-d80667362fb3",
                "code": "PERM_SET_USER_READ",
                "sequence": 9,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "627375e4-7bd4-4889-9e97-ed08ed129b23",
                        "code": "PERM_USER_READ",
                        "name": "PERM_USER_READ",
                        "sequence": 11,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "c3e114d0-7ea7-4de5-b0b2-b9317f9c312c",
        "code": "PERM_GRP_ROLE",
        "sequence": 2,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "37c5f55f-8012-46f9-abd9-04cbd611a6f6",
                "code": "PERM_SET_ROLE_CREATE",
                "sequence": 1,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "6f9ebd69-c35b-4a5b-aaf8-0dcffc4c9bc7",
                        "code": "PERM_ROLE_CREATE",
                        "name": "PERM_ROLE_CREATE",
                        "sequence": 3,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "868a28f3-442f-4b66-ab25-314f96346d4f",
                "code": "PERM_SET_ROLE_READ",
                "sequence": 2,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "586f95ad-73cd-4f85-a418-f079ce42b06f",
                        "code": "PERM_ROLE_READ",
                        "name": "PERM_ROLE_READ",
                        "sequence": 4,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "7ed1c4cb-27aa-4153-aeb9-266149400416",
                "code": "PERM_SET_ROLE_UPDATE",
                "sequence": 3,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "21fd8fb8-7d44-4b94-8a1b-805da8ca463d",
                        "code": "PERM_ROLE_UPDATE",
                        "name": "PERM_ROLE_UPDATE",
                        "sequence": 5,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "764fef34-20fc-4fb6-a93e-7c89b579442f",
        "code": "PERM_GRP_GROUP",
        "sequence": 3,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "34de2258-f0cc-40de-8ebc-0435e6ac452c",
                "code": "PERM_SET_GROUP_CREATE",
                "sequence": 4,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "2fe1592a-48a3-4ee9-a43f-7ed1da1ec88f",
                        "code": "PERM_GROUP_CREATE",
                        "name": "PERM_GROUP_CREATE",
                        "sequence": 6,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "b67c5cc8-690f-49ba-a02d-ce3ff874f6e4",
                "code": "PERM_SET_GROUP_UPDATE",
                "sequence": 5,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "50177912-4703-4f1e-b753-b4200da2340f",
                        "code": "PERM_GROUP_UPDATE",
                        "name": "PERM_GROUP_UPDATE",
                        "sequence": 7,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "bbbd8995-f5ac-4989-86e8-b4e6cae32ec3",
                "code": "PERM_SET_GROUP_READ",
                "sequence": 6,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "2ea10a2b-7d8c-4946-bf88-92b03c4e2972",
                        "code": "PERM_GROUP_READ",
                        "name": "PERM_GROUP_READ",
                        "sequence": 8,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "0276a987-7e89-4971-ac3d-302cfd8f73e8",
        "code": "PERM_GRP_WORKFLOW_FORM",
        "sequence": 4,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "18861dea-88ba-4964-bd7e-98f02f4c285d",
                "code": "PERM_SET_WORKFLOW_FORM_CREATE",
                "sequence": 10,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "299fa023-da19-47e8-85d4-0be551cf389e",
                        "code": "PERM_WORKFLOW_FORM_CREATE",
                        "name": "PERM_WORKFLOW_FORM_CREATE",
                        "sequence": 12,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "2dfcd177-24f1-4ecd-b8f6-ee57692c6466",
                "code": "PERM_SET_WORKFLOW_FORM_READ",
                "sequence": 12,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "a75f4ced-3208-46d1-b9e4-a4fb06d1c7b3",
                        "code": "PERM_WORKFLOW_FORM_READ",
                        "name": "PERM_WORKFLOW_FORM_READ",
                        "sequence": 14,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "bfc3778a-b287-49f7-96da-425ed96b0531",
                "code": "PERM_SET_WORKFLOW_FORM_UPDATE",
                "sequence": 11,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "949c54c0-9738-4665-abcd-e43571d420d5",
                        "code": "PERM_WORKFLOW_FORM_UPDATE",
                        "name": "PERM_WORKFLOW_FORM_UPDATE",
                        "sequence": 13,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "726459a8-4aa4-4d00-9867-e52a070494d7",
        "code": "PERM_GRP_CASE_INFO",
        "sequence": 5,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "1dfe1f59-fcaa-4ead-a9d7-65930f45f144",
                "code": "PERM_SET_CASE_INFO_CREATE",
                "sequence": 13,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "94f8d423-3ae9-443c-affb-afa35a25968c",
                        "code": "PERM_CASE_INFO_CREATE",
                        "name": "PERM_CASE_INFO_CREATE",
                        "sequence": 15,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "003a5c5e-acb0-42cb-acfa-d47763d64445",
                "code": "PERM_SET_CASE_INFO_READ",
                "sequence": 15,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "fc7cd64f-f4df-443e-a916-73ee0925fc93",
                        "code": "PERM_CASE_INFO_READ",
                        "name": "PERM_CASE_INFO_READ",
                        "sequence": 17,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "8e44712b-3e99-4941-94c9-c69b59501853",
                "code": "PERM_SET_CASE_INFO_UPDATE",
                "sequence": 14,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "dd2561f7-a850-4972-92b5-b96f67399727",
                        "code": "PERM_CASE_INFO_UPDATE",
                        "name": "PERM_CASE_INFO_UPDATE",
                        "sequence": 16,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "cd042872-7490-483a-a21c-531f4df27b3e",
        "code": "PERM_GRP_PROCESS_WORKFLOW",
        "sequence": 6,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "6bf2d1df-4dae-40f3-b3f6-afa6af65d861",
                "code": "PERM_SET_PROCESS_WORKFLOW_DISCARD",
                "sequence": 20,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "153ae5cf-220b-4a02-a2c9-17ea1fa465fe",
                        "code": "PERM_PROCESS_WORKFLOW_DISCARD",
                        "name": "PERM_PROCESS_WORKFLOW_DISCARD",
                        "sequence": 22,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "bb0bafd7-5781-4b36-a9d0-dc2a43bcf6b2",
                "code": "PERM_SET_PROCESS_WORKFLOW_POST",
                "sequence": 19,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "3a74b428-ad86-40b3-8c1e-1fe03d9410b2",
                        "code": "PERM_PROCESS_WORKFLOW_POST",
                        "name": "PERM_PROCESS_WORKFLOW_POST",
                        "sequence": 21,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "3755dac5-ae17-4d4b-87ab-cad7007ddcdf",
                "code": "PERM_SET_PROCESS_WORKFLOW_CREATE",
                "sequence": 16,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "3ec97833-e151-45d1-b93e-505708b37be8",
                        "code": "PERM_PROCESS_WORKFLOW_CREATE",
                        "name": "PERM_PROCESS_WORKFLOW_CREATE",
                        "sequence": 18,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "5f5d9681-de57-48bb-b17e-d01a031ad11a",
                "code": "PERM_SET_PROCESS_WORKFLOW_READ",
                "sequence": 18,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "0fbd59f0-52ec-4265-8fd6-80dc5c8328c6",
                        "code": "PERM_PROCESS_WORKFLOW_READ",
                        "name": "PERM_PROCESS_WORKFLOW_READ",
                        "sequence": 20,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "1140191e-f0cc-44ab-8fb1-5b3fa96a641e",
                "code": "PERM_SET_PROCESS_WORKFLOW_UPDATE",
                "sequence": 17,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "0e29b823-244d-4ccf-b01e-e0e90d065100",
                        "code": "PERM_PROCESS_WORKFLOW_UPDATE",
                        "name": "PERM_PROCESS_WORKFLOW_UPDATE",
                        "sequence": 19,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "524691ae-7eb2-4a82-8164-3ee01f3beed8",
        "code": "PERM_GRP_RECEIPT",
        "sequence": 7,
        "category": "ADMIN",
        "permissionSets": []
    },
    {
        "permissionGroupId": "c363e9c8-42ca-4bf7-b451-81ded99f4307",
        "code": "PERM_GRP_COMPANY_INVOICING",
        "sequence": 9,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "43716733-7f7e-4716-8c16-99bed4c990b8",
                "code": "PERM_SET_COMPANY_INVOICING_READ",
                "sequence": 29,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "447b11d8-88b7-4026-91f4-732dac18a501",
                        "code": "PERM_COMPANY_INVOICING_READ",
                        "name": "PERM_COMPANY_INVOICING_READ",
                        "sequence": 31,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "bb5a60fb-fd72-4342-909a-d7660179538f",
                "code": "PERM_SET_COMPANY_INVOICING_CREATE",
                "sequence": 27,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "5f02d49d-be27-41a0-96d7-82a7fdc035c3",
                        "code": "PERM_COMPANY_INVOICING_CREATE",
                        "name": "PERM_COMPANY_INVOICING_CREATE",
                        "sequence": 29,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "a0bb32bd-81fd-4e6a-a9af-56f5cc4217ee",
                "code": "PERM_SET_COMPANY_INVOICING_UPDATE",
                "sequence": 28,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "2ee7d44b-de88-4bfd-82ab-2729b8119c5f",
                        "code": "PERM_COMPANY_INVOICING_UPDATE",
                        "name": "PERM_COMPANY_INVOICING_UPDATE",
                        "sequence": 30,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "2898322a-9d50-4dde-9c14-ab5096c1dbf8",
        "code": "PERM_GRP_EMAIL_GEN",
        "sequence": 10,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "4199d2d8-c010-411d-9bf6-46755f945a2b",
                "code": "PERM_SET_RECEIPT_READ",
                "sequence": 23,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "e4c3fb4b-c83a-4cff-9a76-d1cfa026cf44",
                        "code": "PERM_RECEIPT_READ",
                        "name": "PERM_RECEIPT_READ",
                        "sequence": 25,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "4346e5c2-92b9-472d-9187-558609319d41",
                "code": "PERM_SET_RECEIPT_CREATE",
                "sequence": 21,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "658643f7-d434-434c-81ee-c64b8f542afe",
                        "code": "PERM_RECEIPT_CREATE",
                        "name": "PERM_RECEIPT_CREATE",
                        "sequence": 23,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "463d74a3-2655-4d6f-8d59-b47022e27ca6",
                "code": "PERM_SET_RECEIPT_UPDATE",
                "sequence": 22,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "72433cfe-cbf6-417c-b5bc-699035831d57",
                        "code": "PERM_RECEIPT_UPDATE",
                        "name": "PERM_RECEIPT_UPDATE",
                        "sequence": 24,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "13996258-4197-4c28-bbe1-73718a09b000",
        "code": "PERM_GRP_PROCESSED_USER_TASK",
        "sequence": 11,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "99a82fdf-785d-4478-b266-4b5011b3a2a6",
                "code": "PERM_SET_PROCESSED_USER_TASK_READ",
                "sequence": 30,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "a9ca304c-a208-46fa-a8c6-b9c83df8dfab",
                        "code": "PERM_PROCESSED_USER_TASK_READ",
                        "name": "PERM_PROCESSED_USER_TASK_READ",
                        "sequence": 32,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "ccc64f5a-4452-46e2-9ca7-97e444e26a69",
        "code": "PERM_GRP_COMPANY",
        "sequence": 12,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "190ee9a1-9bad-4e1c-9fdb-e611980213d2",
                "code": "PERM_SET_COMPANY_READ",
                "sequence": 31,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "014ceb05-d5cf-4e44-a362-880c4cba3f50",
                        "code": "PERM_COMPANY_READ",
                        "name": "PERM_COMPANY_READ",
                        "sequence": 33,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "ddc0beed-8190-46c5-b9c2-f7d4d5f6562d",
        "code": "PERM_GRP_INDIVIDUAL",
        "sequence": 13,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "c46ec8c7-46b9-4191-9b60-353f8b36c5de",
                "code": "PERM_SET_INDIVIDUAL_READ",
                "sequence": 32,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "42bae1f0-49b1-4b06-9251-2446efd42709",
                        "code": "PERM_INDIVIDUAL_READ",
                        "name": "PERM_INDIVIDUAL_READ",
                        "sequence": 34,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "fb88ca6c-e31e-478c-a0d6-6c765c4dc4e6",
        "code": "PERM_GRP_AGENT",
        "sequence": 14,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "1aa5ef07-cb31-4c13-8db6-1b6bad2bc3c6",
                "code": "PERM_SET_AGENT_READ",
                "sequence": 33,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "af4af81d-a2db-4322-8824-ffbfc2af1d1c",
                        "code": "PERM_AGENT_READ",
                        "name": "PERM_AGENT_READ",
                        "sequence": 35,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "6c087e1a-1888-4bcf-97ac-96480ca76a15",
        "code": "PERM_GRP_USER_TASK_CAR",
        "sequence": 15,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "79d0f0c3-e58d-45c4-9075-ec0c9e4b892e",
                "code": "PERM_SET_USER_TASK_CAR_SETUP",
                "sequence": 52,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "be1fb327-e5a8-4472-9bf1-cf1ced03040c",
                        "code": "PERM_USER_TASK_CAR_SETUP",
                        "name": "PERM_USER_TASK_CAR_SETUP",
                        "sequence": 54,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "da5e30bd-2a27-4fdb-9585-2eab94830812",
        "code": "PERM_GRP_SYSTEM_SETTING",
        "sequence": 16,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "e269343a-d2cb-41c5-bc96-b4f29ba54ff6",
                "code": "PERM_SET_SYSTEM_SETTING_SETUP",
                "sequence": 53,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "eddd9d85-d49d-481b-838b-e0038215a3de",
                        "code": "PERM_SYSTEM_SETTING_SETUP",
                        "name": "PERM_SYSTEM_SETTING_SETUP",
                        "sequence": 55,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "3303eaf7-e04d-4c85-84dc-2f250c23174b",
        "code": "PERM_GRP_GEN_DOC_TEMP",
        "sequence": 17,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "15767482-ea8c-4c00-97dc-fe8aa8f73278",
                "code": "PERM_SET_GEN_DOC_TEMP_CREATE",
                "sequence": 34,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "36478474-9c9f-4ec4-9fc1-0b3e5a39871e",
                        "code": "PERM_GEN_DOC_TEMP_CREATE",
                        "name": "PERM_GEN_DOC_TEMP_CREATE",
                        "sequence": 36,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "a5b7f5c0-67cd-4137-a2f3-59ff9931616d",
                "code": "PERM_SET_GEN_DOC_TEMP_UPDATE",
                "sequence": 35,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "91dd12aa-786d-453e-80e2-8d47b1dc3c87",
                        "code": "PERM_GEN_DOC_TEMP_UPDATE",
                        "name": "PERM_GEN_DOC_TEMP_UPDATE",
                        "sequence": 37,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "99327d6d-621f-4ad7-bf58-b0e3988d1dca",
                "code": "PERM_SET_GEN_DOC_TEMP_READ",
                "sequence": 36,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "02613af5-2640-4def-bb9c-104b2ef87ffe",
                        "code": "PERM_GEN_DOC_TEMP_READ",
                        "name": "PERM_GEN_DOC_TEMP_READ",
                        "sequence": 38,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "2aabcaf5-afc5-46e6-b7ce-f4b4f2063331",
        "code": "PERM_GRP_DOC_UPLOAD",
        "sequence": 18,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "0dc09b87-40a8-4b89-ac83-abd6735aa627",
                "code": "PERM_SET_DOC_UPLOAD_CREATE",
                "sequence": 37,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "a38bfd54-dfa0-4659-a784-a61febada50d",
                        "code": "PERM_DOC_UPLOAD_CREATE",
                        "name": "PERM_DOC_UPLOAD_CREATE",
                        "sequence": 39,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "91cc051a-5980-4ba5-82be-3761c9c501c3",
                "code": "PERM_SET_DOC_UPLOAD_UPDATE",
                "sequence": 38,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "6e3a5bfa-b2d0-4d6b-9466-3683a71a0981",
                        "code": "PERM_DOC_UPLOAD_UPDATE",
                        "name": "PERM_DOC_UPLOAD_UPDATE",
                        "sequence": 40,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "c239ebe1-dc58-4aea-8eca-5108315775df",
                "code": "PERM_SET_DOC_UPLOAD_READ",
                "sequence": 39,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "fce37e20-8e80-4cc2-b839-3d69249979f7",
                        "code": "PERM_DOC_UPLOAD_READ",
                        "name": "PERM_DOC_UPLOAD_READ",
                        "sequence": 41,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "a4fbbe0b-8928-4b89-9589-ef56816d535e",
        "code": "PERM_GRP_JURISDICTION",
        "sequence": 19,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "d0be87d0-e31c-4b48-b6e8-8ee83d82d09d",
                "code": "PERM_SET_JURISDICTION_CREATE",
                "sequence": 40,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "914e08ab-b648-441d-8410-7a6ebdefe163",
                        "code": "PERM_JURISDICTION_CREATE",
                        "name": "PERM_JURISDICTION_CREATE",
                        "sequence": 42,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "0740160d-8db1-464f-a8a1-1c70173f3b7b",
                "code": "PERM_SET_JURISDICTION_UPDATE",
                "sequence": 41,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "64344348-833f-4d8a-b364-077db06413aa",
                        "code": "PERM_JURISDICTION_UPDATE",
                        "name": "PERM_JURISDICTION_UPDATE",
                        "sequence": 43,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "de6d728b-d3e6-47cc-a23d-48862bd64318",
                "code": "PERM_SET_JURISDICTION_READ",
                "sequence": 42,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "65d59305-9b1f-42a0-8aed-cc612b25e87f",
                        "code": "PERM_JURISDICTION_READ",
                        "name": "PERM_JURISDICTION_READ",
                        "sequence": 44,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "f2b670a3-a723-4441-b76e-635fc3cf78ab",
        "code": "PERM_GRP_COMPANY_INVOICING",
        "sequence": 20,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "388fb3e7-4b4f-4de7-ae26-380427883d8b",
                "code": "PERM_SET_COMPANY_INVOICING_UPDATE",
                "sequence": 43,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "2a2158a4-461e-47c2-955e-690f76e0ec9d",
                        "code": "PERM_COMPANY_INVOICING_CREATE",
                        "name": "PERM_COMPANY_INVOICING_CREATE",
                        "sequence": 45,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "2638ff1f-fe6d-4c99-9d53-f06bd29de814",
                "code": "PERM_SET_COMPANY_INVOICING_READ",
                "sequence": 45,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "617bbdfe-2c70-4d9c-a7c1-48b8b878e790",
                        "code": "PERM_COMPANY_INVOICING_READ",
                        "name": "PERM_COMPANY_INVOICING_READ",
                        "sequence": 47,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "71f05ccc-00a5-4f27-adb1-29f933aec9c8",
                "code": "PERM_SET_COMPANY_INVOICING_UPDATE",
                "sequence": 44,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "9acbc574-9f68-451f-9317-4174dbfe23d2",
                        "code": "PERM_COMPANY_INVOICING_UPDATE",
                        "name": "PERM_COMPANY_INVOICING_UPDATE",
                        "sequence": 46,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "adde730b-ab14-4d11-8299-3a90ba79495b",
        "code": "PERM_GRP_MASTER_INFO",
        "sequence": 21,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "e7b59d6c-d1bd-4499-947d-2de205456979",
                "code": "PERM_SET_MASTER_INFO_CREATE",
                "sequence": 46,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "26f85002-45eb-4fbe-ab7b-aac833439e86",
                        "code": "PERM_MASTER_INFO_CREATE",
                        "name": "PERM_MASTER_INFO_CREATE",
                        "sequence": 48,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "b073f60b-1e37-4f28-a240-50549f3a2967",
                "code": "PERM_SET_MASTER_INFO_UPDATE",
                "sequence": 47,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "b859cfa5-a2ac-47d0-9e2a-28131e07cabb",
                        "code": "PERM_MASTER_INFO_UPDATE",
                        "name": "PERM_MASTER_INFO_UPDATE",
                        "sequence": 49,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "628653e8-bdfe-4819-8349-d21510d45264",
                "code": "PERM_SET_MASTER_INFO_READ",
                "sequence": 48,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "0374a99c-1224-4c8a-94c0-25295d8dc047",
                        "code": "PERM_MASTER_INFO_READ",
                        "name": "PERM_MASTER_INFO_READ",
                        "sequence": 50,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    },
    {
        "permissionGroupId": "0839e936-c312-4b78-a971-dd2644c3cda0",
        "code": "PERM_GRP_EMAIL_TEMPLATE",
        "sequence": 22,
        "category": "ADMIN",
        "permissionSets": [
            {
                "permissionSetId": "d8023416-5176-49e4-9c42-a50f496d6086",
                "code": "PERM_SET_EMAIL_TEMPLATE_CREATE",
                "sequence": 49,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "219a9bc0-fcbb-4f63-832e-aed52bcaa6cb",
                        "code": "PERM_EMAIL_TEMPLATE_CREATE",
                        "name": "PERM_EMAIL_TEMPLATE_CREATE",
                        "sequence": 51,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "024ca4aa-38b4-4aba-ad55-2fa2e133d820",
                "code": "PERM_SET_EMAIL_TEMPLATE_UPDATE",
                "sequence": 50,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "504e3e75-f2c5-430d-9848-56d1113d82d4",
                        "code": "PERM_EMAIL_TEMPLATE_UPDATE",
                        "name": "PERM_EMAIL_TEMPLATE_UPDATE",
                        "sequence": 52,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            },
            {
                "permissionSetId": "065c5008-b1db-43a7-9fd1-e74298340cde",
                "code": "PERM_SET_EMAIL_TEMPLATE_READ",
                "sequence": 51,
                "type": "ADMIN",
                "permissions": [
                    {
                        "permissionId": "c653599f-3145-415e-bea8-3b53427ac929",
                        "code": "PERM_EMAIL_TEMPLATE_READ",
                        "name": "PERM_EMAIL_TEMPLATE_READ",
                        "sequence": 53,
                        "description": null,
                        "type": "ADMIN"
                    }
                ]
            }
        ]
    }
]

@Injectable()
export class MockPermissionGroupService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService
    ) { }


    get(): Observable<PermissionGroup[]> {
        return of(itemOne);
    }
}